import 'owl.carousel';

jQuery( document ).ready(function($) {
    $('.searchtoggle').on('click', function(e){
        e.preventDefault(); 
        $('#search-bar').toggleClass('open');
    })
    $('.menu-toggle').on('click', function(e){
        e.preventDefault(); 
        $('.menu-wrapper').toggleClass('open');
    })
    $('.selector').on('click', function(e){
        e.preventDefault();
        let targets = $(this).attr('data-target');
        let newActive = $(this).attr('href');
        if ($(this).hasClass('active')){
            $(this).removeClass('active'); 
            $('.selector').removeClass('active');
            $(targets).removeClass('active');
        } else {
            $('.selector').removeClass('active');
            $(this).addClass('active');
            $(targets).removeClass('active');
            $(newActive).addClass('active');
        }
    })

    $('.banner-slider').owlCarousel({
        loop:true,
        margin:0,
        nav:true,
        dots: false,
        items: 1,
        navText: ['<i class="far fa-circle-chevron-left" aria-label="Previous"></i>','<i class="far fa-circle-chevron-right" aria-label="Next"></i>'],
    })

    $('.news-slider').owlCarousel({
        loop:true,
        margin:30,
        nav:true,
        dots: false,
        navText: ['<i class="fas fa-chevron-left" aria-label="Previous"></i>','<i class="fas fa-chevron-right" aria-label="Next"></i>'],
        responsive:{
            0:{
                items:1
            },
            600:{
                items:2
            },
            1000:{
                items:3
            }
        }
    })
});